import React from "react";
import { userprofile } from "../../Model/Users"; //Include Home
import { Link } from "react-router-dom";

import { withRouter, VirsionCheck, Faq } from "../../Helpers/Common"; //Include Home
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import BarLoader from "react-spinners/BarLoader";
import Profilemenu from "../Profile_menu/Profilemenu";
import { motion } from "framer-motion";
import $ from "jquery";
import Parser from "html-react-parser";
import { Metadata } from "../Metadata/Metadata";
//import './HelpnsupportMobile.css'
var ImageData = "";
var SVGIcon = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

class TermsofuseMobile extends React.Component {
  hideshow() {
    $(".temp3-item .temp3-head")
      .unbind()
      .click(function () {
        var activeTitle = $(this).hasClass("temp3Active");
        $(".temp3-item .temp3-head")
          .removeClass("temp3Active")
          .siblings(".temp3-content")
          .slideUp();
        if (!activeTitle) {
          $(this).addClass("temp3Active").next(".temp3-content").slideDown();
        }
      });
  }

  constructor(props) {
    super(props);
    this.state = {
      VirsionCheckData: [],
      VirsionCheckDataloaded: false,
      DataisLoaded: false,
      MoreFaq: false,
      userData: false,
      VirsionCheck: false
    };
  }

  componentDidMount() {
    //Get Virsion Check Data
    VirsionCheck().then((vcheckres) => {
      Faq("DocuBayFAQ", 10).then((FaqRes) => {
        if (FaqRes.data.body) {
          var Faqs = JSON.parse(FaqRes.data.body);
          this.setState({
            VirsionCheckData: vcheckres,
            VirsionCheckDataloaded: true,
            DataisLoaded: true,
            MoreFaq: Faqs.data.faq,
          });
        }
      });
    });
  }

  backbtn() {
    this.props.navigate("/profile");
  }

  render() {
    if (this.state.VirsionCheckDataloaded == false) {
      return <div className="loader"><BarLoader color="#ff000f" /></div>;
    } else {
      return (
        <>
          <motion.div
            className=""
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
            key="1"
          >
            <Metadata page="HELP-SUPPORT" />
            <main>
              <div className="webviewpages setting-main">
                <section className="mb-0">
                  <div className="temp47 temp47n">
                    <div className="temp47-inn mt-0">
                      <div className="temp47-help-text">
                        FAQs{" "}
                        {/* <Link to="/faqs">
                          {" "}
                          <span>
                            View All <img src={SVGIcon["red-right-arrow.svg"]} />{" "}
                          </span>{" "}
                        </Link>{" "} */}
                      </div>
                      <div className="temp3">
                        <div className="temp3-tabList">
                          <div className="temp3-tabItem">
                            {this.state.MoreFaq.map((data, index) => {

                              return (
                                <div className="temp3-item">
                                  <div
                                    className="temp3-head"
                                    onClick={() => {
                                      this.hideshow();
                                    }}
                                  >
                                    <p className="white">{data.question}</p>
                                    <span className="temp3-headBtn">
                                      <img src={SVGIcon["arrow-down.svg"]} />
                                    </span>
                                  </div>
                                  <div className="temp3-content">
                                    <p>
                                      {Parser(
                                        data.answer.split("<br />").join("\n")
                                      )}
                                    </p>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                      <div class="pb-m"></div>
                    </div>
                  </div>
                </section>
                <div className="dD-block">
                  <Profilemenu versioncheck={this.state.VirsionCheckData} profile={this.state.userData} />
                </div>
              </div>
            </main>
          </motion.div>
        </>
      );
    }
  }
}
export default withRouter(TermsofuseMobile);